<template>
    <div class="content">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style>
.content {
    grid-area: content;
    background: linear-gradient(to right, #141e30, #243b55);
    padding: 25px;
}
</style>
